import React from 'react'
import './intro.css'
import Github from '../../img/github.png'
import LinkedIn from '../../img/linkedin.png'
import Instagram from '../../img/instagram.png'
import Vector1 from '../../img/Vector1.png'
import Vector2 from '../../img/Vector2.png'
import profile from '../../img/kabita.png'
import Crown from '../../img/crown.png'
import glassesimoji from '../../img/glassesimoji.png'
import FloatingDiv from '../floatingDiv/FloatingDiv'




const Intro = () => {



  return (

      <div className="intro" id="intro" >
        <div className="i-left">
            <div className="i-name">
                <span>Hi! I am</span>
                <span>Kabita Aryal</span>
                <span>Web Designer with  high 
                 level of experience in Web
                 designing and development and currently 
                 working in this field, producting
                 the Quality work</span>
            </div>

            
            <div className="i-icons">
                <a href="https://github.com/kabita888">
               <img src={Github} alt="" />
                </a>
               <a href="https://www.linkedin.com/in/kabita-aryal-571458342/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BOwxtawqzSGmt%2FiyBTKiZAw%3D%3D">
                <img src={LinkedIn} alt="" />
                </a>
               
               <a href="https://www.instagram.com/kabita.aryal.https://www.instagram.com/kabita.aryal.1675/?hl=en/?hl=en">
               <img src={Instagram} alt="" />
                </a>
            </div>
        </div>
        <div className="i-right">
         <img src={Vector1} alt="" />
         <img src={Vector2} alt="" />
         <img src={profile} alt="" />
         <img src={glassesimoji} alt="" className="glassesimoji" />
         <div style={{top: '24%', left: '68%'}}
         className='floating-div'>
            <FloatingDiv image={Crown}  txt1='Web' txt2='Designer'/>
         </div>
         <div className='blur' style={{ background: "rgb(238 210 255)"}}>

         </div>
         <div className="blur" style={{background: '#C1F5FF', top: '17rem', width: '21rem', height:'11rem', left: '-9rem'}}></div>


        </div>
      </div>
      
  )
}

export default Intro
